import { Box, Link } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import React from 'react';

const useStyles = makeStyles()((theme) => ({
  titleLogin: {
    display: 'flex',
    flexDirection: 'column-reverse',
    flexGrow: 1,
  },
  link: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
    width: '100%',
    left: 0,
    '& a': {
      marginLeft: '20px',
    },
  },
  info: {
    margin: 0,
  }
}));

export const LoginFooter: React.VFC<{ isAutoSignOut: boolean }> = ({ isAutoSignOut }) => {
  const l10n = useL10n();
  const { classes } = useStyles();

  if (isAutoSignOut) {
    return null;
  }

  return (
    <Box className={classes.link}>
      <p className={classes.info}>{l10n.auth.newToUplift}</p>
      <Link href="https://www.betterhelp.com/psychiatry/" rel="noreferrer" target="_blank">
        {l10n.navigation.learnMore}
      </Link>
    </Box>
  );
};
